var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// window.moment = moment;
// require('bootstrap-five');

// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
// require('bootstrap-five/js/dist/collapse');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/accordion');
require('bootstrap-five/js/dist/dropdown');
require('bootstrap-five/js/dist/tab');
require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/tooltip');

require('webticker/jquery.webticker.js');


import MmenuLight from 'mmenu-light';
window.MmenuLight = MmenuLight;

document.addEventListener("DOMContentLoaded", () => {
    const menuElement = document.querySelector("#menu");
    if (menuElement) {
        const menu = new MmenuLight(
            menuElement,
            "(max-width: 991.98px)"
        );

        const navigator = menu.navigation({
            title: 'Menu',
            selectedClass: 'active',
            slidingSubmenus: true,
            theme: 'light'
        });

        const drawer = menu.offcanvas({
            position: 'left'
        });

        // Open/close menu when hamburger is clicked
        document.querySelectorAll('a[href="#menu"]').forEach(function(trigger) {
            trigger.addEventListener('click', function(evnt) {
                evnt.preventDefault();
                if (document.body.classList.contains('mm-ocd-opened')) {
                    drawer.close();
                } else {
                    drawer.open();
                }
            });
        });
    }
});


// Swiper
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
// import '/js/plugins/slider-menu.js';


// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');


// require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    // Swiper carousel initialization
    if ($('.page-images-swiper').length ) {
        $('.page-images-swiper').each(function() {
            var $swiperEl = $(this);
            var hasMultipleSlides = $swiperEl.find('.swiper-slide').length > 1;
            var zoomTimeout;

            function startCycle(swiper) {
                var slide = swiper.slides[swiper.activeIndex];
                var img = slide ? slide.querySelector('img') : null;
                if (!img) return;

                img.style.transform = 'scale(1)';
                setTimeout(function() {
                    img.style.transition = 'transform 3s ease-out';
                    img.style.transform = 'scale(1.15)';
                }, 50);

                zoomTimeout = setTimeout(function() {
                    if (!swiper.destroyed) swiper.slideNext();
                }, 4000);
            }

            var swiper = new Swiper(this, {
                effect: 'fade',
                fadeEffect: { crossFade: true },
                loop: hasMultipleSlides,
                speed: 800,
                pagination: {
                    el: $swiperEl.find('.swiper-pagination')[0],
                    clickable: true,
                    dynamicBullets: true,
                },
                on: {
                    init: function() {
                        if (hasMultipleSlides) startCycle(this);
                    },
                    slideChangeTransitionStart: function() {
                        if (zoomTimeout) {
                            clearTimeout(zoomTimeout);
                            var prevImg = this.slides[this.previousIndex]?.querySelector('img');
                            if (prevImg) prevImg.style.transform = 'scale(1)';
                        }
                    },
                    slideChangeTransitionEnd: function() {
                        var img = this.slides[this.activeIndex]?.querySelector('img');
                        if (img) {
                            img.style.transform = 'scale(1)';
                            img.style.transition = 'transform 3s ease-out';
                        }
                        if (hasMultipleSlides && !this.destroyed) {
                            setTimeout(function() { startCycle(swiper); }, 200);
                        }
                    }
                }
            });
        });
    }



    // $('.hamburger').click(function(){
    //     $(this).toggleClass("is-active");
    //      $('.sidebar-offcanvas').toggleClass('active');
    //     //  $('.main-nav').toggleClass('down');
    // });

    // Webticker initialization
    $('.webticker').each(function() {
        var $ticker = $(this);
        if (!$ticker.data('webticker-initialized')) {
            $ticker.data('webticker-initialized', true);
            $ticker.webTicker({
                startEmpty: false,
                duplicate: true,
                height: "280px",
                hoverpause: false,
                speed: 40,
            });
        }
    });

    // Smooth scroll with header offset for anchor links
    $('a[href^="#"]').on('click', function(e) {
        var target = $(this.getAttribute('href'));
        if (target.length) {
            e.preventDefault();
            var headerHeight = $('#header').outerHeight() || 0;
            var offset = headerHeight;

            $('html, body').animate({
                scrollTop: target.offset().top - offset
            }, 600, 'easeInOutCubic');
        }
    });
});



window.recaptchaInit = function (parent) {
    let gClass = '.g-recaptcha';
    if (parent !== undefined) {
        gClass = parent + ' .g-recaptcha';
    }
    $(gClass).each(function() {
        var el = $(this);
        if (grecaptcha) {
            try {
                grecaptcha.render($(el).attr("id"), {});
            } catch(error){
                // duplicate errors
            }
        }
    });
    window.dispatchEvent(new CustomEvent('recaptcha-init'));
}
